// Course 5004
import { SharedParams } from './shared-params.const';

const CourseService = '/course-management';

// Controllers
const CategoryController = `${CourseService}/categories`;
const UserFeedbackController = `${CourseService}/feedback/`;
const CourseContentController = `${CourseService}/course-contents`;
const CourseEvaluationController = (courseId) => `${CourseService}/courses/${courseId}/evaluations`;
const CourseGeneralBriefController = (courseId) => `${CourseService}/courses/${courseId}/general-briefs`;
const CourseController = `${CourseService}/courses`;
const CourseTopicController = (courseId) => `${CourseService}/courses/${courseId}/topics`;
const CourseDiscussionLikeController = (referenceId, referenceType) =>`${CourseService}/discussion/likes/${referenceId}/${referenceType}`;
const CourseTopicCommentController = (courseId, topicId) => `${CourseService}/courses/${courseId}/topics/${topicId}/comments`;
const CourseFaqQuestionController = (courseId) => `${CourseService}/courses/${courseId}/faq-questions`;
const LanguageController = `${CourseService}/languages`;
const LearningPathController = `${CourseService}/learning-paths`;
const CourseMediaController = `${CourseService}/course-media`;
const CourseVoteController = `${CourseService}/course-votes`;
const WebexMeetingController = `${CourseService}/webex-meetings`;
const DigitalLibraryController = `${CourseService}/DigitalLibrary`;

export const CourseManagementService = {
    UserFeedback: {
        Controller: UserFeedbackController,
        CourseFeedback: (courseId: number) => `${UserFeedbackController}${courseId}`,
        UsersFeedbacks: (courseId: number) => `${UserFeedbackController}${courseId}/all-feedbacks`,
        CheckUserFeedback: (courseId: number) => `${UserFeedbackController}${courseId}/checking-feedback`,
    },
    Category: {
        Categories: CategoryController,
        CategoryStatus: (categoryId, status) => `${CategoryController}/${categoryId}/${status}`,
        SubCategories: (mainCategoryId) => `${CategoryController}/${mainCategoryId}/sub-categories`,
        UploadingCategoryImage: (categoryId) => `${CategoryController}/${categoryId}/${SharedParams.Uploading}-category-image`,
    },
    CourseContent: {
        CourseContents: CourseContentController,
        CourseSections: (courseId) => `${CourseContentController}/${courseId}/sections`,
        CourseContentTranslate: `${CourseContentController}/translate`,
        CourseContentProgress: (courseId) => `${CourseContentController}/${courseId}/progress`,
        CourseSection: (courseId, sectionId) => `${CourseContentController}/${courseId}/sections/${sectionId}`,
        ContentDetails: (contentId) => `${CourseContentController}/${contentId}`,
        ScormContent: (path) => `${CourseContentController}/scorm/${path}`,
        CourseContentWeight: `${CourseContentController}/content-weight`,
        CurrentSession: `${CourseContentController}/current-session`,
    },
    CourseEvaluation: {
        CoursesEvaluations: (courseId) => CourseEvaluationController(courseId),
        CoursesEvaluationsActiveAxes: (courseId) => `${CourseEvaluationController(courseId)}/active-axes`,
        CoursesEvaluationsSettings: (courseId) => `${CourseEvaluationController(courseId)}/settings`,
        CoursesEvaluationsComments: (courseId) => `${CourseEvaluationController(courseId)}/comments`,
        CoursesEvaluationsStatus: (courseId, status) => `${CourseEvaluationController(courseId)}/${status}`,
        CoursesEvaluationsAxis: (courseId, evaluationAxisId) => `${CourseEvaluationController(courseId)}/${evaluationAxisId}`,
        CoursesEvaluationsAxesSettings: (courseId) => `${CourseEvaluationController(courseId)}/axes-settings`,
        CoursesEvaluationsElements: (courseId) => `${CourseEvaluationController(courseId)}/evaluation-elements`,
        CoursesEvaluationsElement: (courseId, elementId) => `${CourseEvaluationController(courseId)}/evaluation-elements/${elementId}`,
    },
    CourseGeneralBrief: {
        CourseGeneralBriefs: (courseId) => CourseGeneralBriefController(courseId),
        CourseGeneralBriefId: (courseId, generalBriefId) => `${CourseGeneralBriefController(courseId)}/${generalBriefId}`,
    },
    Course: {
        Courses: CourseController,
        RelatedCourses: (courseId) => `${CourseController}/${courseId}/similar-courses`,
        CoursesStatus: (courseId, status) => `${CourseController}/${courseId}/${status}`,
        ActiveCourses: `${CourseController}/active-courses`,
        CourseUploading: (courseId) => `${CourseController}/${courseId}/${SharedParams.Uploading}`,
        DashboardInformation: `${CourseController}/${SharedParams.Dashboard}/information`,
        CourseSections: (courseId) => `${CourseController}/${courseId}/sections`,
        CourseTimeline: (courseId) => `${CourseController}/${courseId}/timeline`,
        CourseCertificate: (courseId) => `${CourseController}/${courseId}/certificate`,
        CourseAdvertisements: (courseId) => `${CourseController}/${courseId}/advertisements`,
        CourseDefaultImages: `${CourseController}/default-images`,
        CourseLiveSessions: (courseId) => `${CourseController}/${courseId}/live-sessions`,
        CourseInstructors: (courseId) => `${CourseController}/${courseId}/instructors`,
        CourseInstructorsDetails: (courseId) => `${CourseController}/${courseId}/instructors/details`,
        InstructorBill: `${CourseController}/instructors/bill`,

    },
    CourseTopics: {
        CourseTopics: (courseId) => CourseTopicController(courseId),
        PendgingTopics: (courseId) => `${CourseTopicController(courseId)}/pending`,
        Topic: (courseId, topicId) => `${CourseTopicController(courseId)}/${topicId}`,
        UploudTopicFile: (courseId, topicId, contentType) => `${CourseTopicController(courseId)}/${topicId}/upload-file/${contentType}`,

    },
    CourseTopicComments: {
        CourseTopicComments: (courseId, topicId) => CourseTopicCommentController(courseId, topicId),
        pendingComments: (courseId, topicId) => `${CourseTopicCommentController(courseId, topicId)}/pending`,
        Comment: (courseId, topicId, commentId) => `${CourseTopicCommentController(courseId, topicId)}/${commentId}`,
    },
    CourseFaqQuestion: {
        CourseFaqQuestions: (courseId) => CourseFaqQuestionController(courseId),
        FaqQuestion: (courseId, faqQuestionId) => `${CourseFaqQuestionController(courseId)}/${faqQuestionId}`,
    },
    Language: {
        Languages: LanguageController,
        LanguageId: (languageId) => `${LanguageController}/${languageId}`,
    },
    LearningPath: {
        LearningPaths: LearningPathController,
        LearningPathDetail: (learningPathId) => `${LearningPathController}/${learningPathId}/details`,
        LearningPathUploading: (learningPathId) => `${LearningPathController}/${learningPathId}/${SharedParams.Uploading}`,
        LearningPathStatus: (learningPathId, status) => `${LearningPathController}/${learningPathId}/${status}`,
        StudentLearningPath: `${LearningPathController}/student`,
    },
    CourseMedia: {
        Media: CourseMediaController,
        MediaPath: (path) => `${CourseMediaController}/${path}`,
    },
    CourseVote: {
        CourseVotes: CourseVoteController,
        VoteQuestion: (voteId) => `${CourseVoteController}/${voteId}`,
    },
    WebexMeeting: {
        WebexMeetings: WebexMeetingController,
        WebexMeetingParticipants: `${WebexMeetingController}/participants`,
        WebexMeetingId: (meetingId) => `${WebexMeetingController}/${meetingId}`,
        WebexMeetingWebLink: `${WebexMeetingController}/web-link`,
        WebexMeetingJoin: `${WebexMeetingController}/web-link-joining`,
    },
    DigitalLibrary: {
        Controller: `${DigitalLibraryController}`,
        GetCategoryContents: `${DigitalLibraryController}/GetCategoryContents`,
        GetCategoryDropDown: `${DigitalLibraryController}/dropdown`,
        GetContent: `${DigitalLibraryController}/GetContent`,
    },
    DiscussionLike :{
        DiscussionLike: (referenceId, referenceType) =>`${CourseDiscussionLikeController(referenceId, referenceType)}`
    }
};
